





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Listings } from '@/Listings'
import { MomentListed, sortOrderTypes } from '@/MomentListed'
import * as utils from '@/utils';
import * as utils_topshot from '@/utils_topshot';
import MomentListedListComponent from '@/components/MomentListedListComponent.vue';                               // @ is an alias to /src
import { IPaginationResult } from '@/PaginationResult'
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src
import { Challenge } from '@/Challenge'

@Component({
  name: 'ListingsComponent',
  components: { MomentListedListComponent, MomentSelectorAndSorterComponent }
})
export default class ListingsComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public flowAddress: string = null;
  public moments: MomentListed[] = []
  public listings: Listings = null
  public paginationResult: IPaginationResult = null
  public numMoments: number = null
  public fmv: number = null
  public costBasis: number = null

  // UI and filter options
  public sortOrder: sortOrderTypes = this.getSortOrders()[0].sort

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  // events from MomentSelectorAndSorterComponent
  public async onChangedSort(sortOrder: { label: string, sort: sortOrderTypes }) {
    this.sortOrder = sortOrder.sort
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }
  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.setID = duo.setID || set.setID
    this.playID = duo.playID
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  public getSortOrders(): Array<{ label: string, sort: sortOrderTypes }> {
    return [
        { label: 'Sort by Listed (recent)', sort: 'ListedDate_DESC' },
        { label: 'Sort by Listed (oldest)', sort: 'ListedDate_ASC' },
        { label: 'Sort by Acquired (recent)', sort: 'AcquiredDate_DESC' },
        { label: 'Sort by Acquired (oldest)', sort: 'AcquiredDate_ASC' },
        { label: 'Sort by Asking (highest)', sort: 'ListedPrice_DESC' },
        { label: 'Sort by Asking (lowest)', sort: 'ListedPrice_ASC' },
        { label: 'Sort by FMV (highest)', sort: 'FMV_DESC' },
        { label: 'Sort by FMV (lowest)', sort: 'FMV_ASC' },
        { label: 'Sort by Paid (highest)', sort: 'AcquiredPrice_DESC' },
        { label: 'Sort by Paid (lowest)', sort: 'AcquiredPrice_ASC' },
        { label: 'Sort by Possible Gain', sort: 'Gain_DESC' },
        { label: 'Sort by Possible Loss', sort: 'Gain_ASC' },
        { label: 'Sort by 24h Gains', sort: 'Movement_DESC' },
        { label: 'Sort by 24h Losses', sort: 'Movement_ASC' },
    ]
  }

  public async setFlowAddress(flowAddress: string, forceRefetch: boolean) {
    if (forceRefetch || !this.listings || flowAddress !== this.flowAddress) {
      this.flowAddress = flowAddress
      this.pageNumberToLoadNext = 1
      this.listings = null
      this.numMoments = 0
      this.moments = []
      this.paginationResult = null
      await this.fetchData(false, this.pageNumberToLoadNext)
    }
  }

  public getNiceGainString(): string {
    return utils_topshot.getNiceGainString(this.fmv - this.costBasis)
  }
  public getGainClass(): string {
    return utils_topshot.getGainClass(this.fmv - this.costBasis)
  }  

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1
  private playerID: number = null
  private setID: number = null
  private playID: number = null

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);
  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // the reason for pageNumberWhenCalled is for race-condition prevention
  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    const header: MomentListed = new MomentListed(null)
    header.momentID = 0
    header.valueFMV = 0

    if (!this.flowAddress) return 0
    let url: string = utils.getURLprefix() + `/api/topshot/listings/`;
    url += this.flowAddress
    url += `?page=${pageNumberWhenCalled}`;
    url += `&sortOrder=${this.sortOrder}`;
    if (this.playerID) url += `&playerID=${this.playerID}`
    if (this.setID) url += `&setID=${this.setID}`
    if (this.playID) url += `&playID=${this.playID}`
    if (!utils_topshot.getChallenges()) url += `&sc=true`

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`ListingsComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // challenges
      if (response.data.challenges) utils_topshot.setChallenges(response.data.challenges.map((po) => new Challenge(po)))
      if (response.data.expiredChallenges) utils_topshot.setExpiredChallenges(response.data.expiredChallenges.map((po) => new Challenge(po)))

      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up subtotals
      this.numMoments = response.data.numMoments
      this.fmv = response.data.fmv
      this.costBasis = response.data.costBasis

      // load up the Listings
      this.listings = new Listings(response.data.listings)

      // load up the moments separately from the Listings object in case we want to do paging (might do everything inside Listings eventually)
      let newRawItems: MomentListed[] = response.data.listings.moments
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new MomentListed(po));
        if (pageNumberWhenCalled === 1) this.moments = [ header ].concat(newRawItems);
        else this.moments = this.moments.concat(newRawItems)

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }
    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded ${this.moments.length} moments}`)
  }
}
